import { render, staticRenderFns } from "./order_list.vue?vue&type=template&id=3c4ec18b&scoped=true"
import script from "./order_list.vue?vue&type=script&lang=js"
export * from "./order_list.vue?vue&type=script&lang=js"
import style0 from "./order_list.vue?vue&type=style&index=0&id=3c4ec18b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4ec18b",
  null
  
)

export default component.exports